(function () {
    angular.module('st').controller('stLoadNextFacetSearchResultsCtrl', LoadNextFacetSearchResultsCtrl);

    LoadNextFacetSearchResultsCtrl.$inject = ['$rootScope', 'stFacetService', '$location'];

    function LoadNextFacetSearchResultsCtrl($rootScope, facetService, $location) {
        var _this = this;
        this.facetService = facetService;
        this.group = st.search.DefaultGroup;
        this.pages = [];

        $rootScope.$on('stRegisterFacets', function (e) {
            _this.facetService.registerFacets(_this.group);
        });

        $rootScope.$on('stFacetsInit', function (e, search, groups) {
            var curPage = _this.facetService.getPageId(_this.group);
            var pageChanged = _this.selectPageId(curPage, false);
            if (pageChanged) {
                groups.push(_this.group);
            }
        });

        $rootScope.$on('stSearchResponse', function (e, response, group) {
            if (!angular.isUndefined(group) && group === _this.group) {
                if (Array.isArray(response)) {
                    if (response.length) {
                        this.results = response[response.length - 1];
                    }
                } else {
                    _this.results = response;
                }
                if (_this.results) {
                    _this.pages.length = _this.results.Pages;
                    for (var i = 0; i < _this.results.Pages; i++) {
                        if (_this.pages[i]) {
                            _this.pages[i].isActive = i === _this.results.Page - 1;
                        }
                        else {
                            _this.pages[i] = {
                                id: i + 1,
                                isActive: i === _this.results.Page - 1
                            };
                        }
                    }
                }
                else {
                    _this.pages.length = 0;
                }


                $rootScope.$watch(function () {
                    if ($('.popup-video').length > 0) {

                        $('.popup-video').each(function () {
                            $(this).magnificPopup({
                                disableOn: 575,
                                type: 'iframe',
                                preloader: false,
                                fixedContentPos: true
                            });
                        });

                    }
                });
            }
        });
    }


    Object.defineProperty(LoadNextFacetSearchResultsCtrl.prototype, "isSearching", {
        get: function () {
            return this.facetService.isSearching[this.group];
        },
        enumerable: true,
        configurable: true
    });

    LoadNextFacetSearchResultsCtrl.prototype.selectPage = function (page) {
        $('html, body').animate({ scrollTop: 0 }, 100);
        return this.selectPageId(page.id, true);
    };

    LoadNextFacetSearchResultsCtrl.prototype.selectPageId = function (id, notify) {

        var pageChanged = false;
        this.pages.forEach(function (page) {
            if (page.id === id) {
                if (!page.isActive) {
                    page.isActive = true;
                    pageChanged = true;
                }
            }
            else {
                if (page.isActive) {
                    page.isActive = false;
                    pageChanged = true;
                }
            }
        });
        if (pageChanged && notify) {
            this.facetService.setPage(id, this.group);
        }
        return pageChanged;
    };
    LoadNextFacetSearchResultsCtrl.prototype.nextPage = function () {
        var idChanged = 0;
        for (var i = 0; i < this.pages.length; i++) {
            var page = this.pages[i];
            if (page.isActive) {
                if (i + 1 < this.pages.length) {
                    page.isActive = false;
                    this.pages[i + 1].isActive = true;
                    idChanged = this.pages[i + 1].id;
                }
                break;
            }
        }
        if (idChanged > 0) {
            this.facetService.setPage(idChanged, this.group);
            $('html, body').animate({ scrollTop: 0 }, 100);
            return true;
        }
        return false;
    };
    LoadNextFacetSearchResultsCtrl.prototype.prevPage = function () {
        var idChanged = 0;
        for (var i = 0; i < this.pages.length; i++) {
            var page = this.pages[i];
            if (page.isActive) {
                if (i > 0) {
                    page.isActive = false;
                    this.pages[i - 1].isActive = true;
                    idChanged = this.pages[i - 1].id;
                }
                break;
            }
        }
        if (idChanged > 0) {
            this.facetService.setPage(idChanged, this.group);
            $('html, body').animate({ scrollTop: 0 }, 100);
            return true;
        }
        return false;
    };
    LoadNextFacetSearchResultsCtrl.prototype.takeEven = function (item, i, array) {
        return i % 2;
    };

})();